import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { authActions } from "../../store/auth";
const Support = () => {
  const dispatch = useDispatch();
  //   const access = useSelector((state) => state.auth.access);

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });
  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Support
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                    alt="img"
                    className="mt-4"
                  />
                  <br />
                  <h2>Welcome to VidAmaze Dashboard</h2>

                  <h5 className="mt-3 text-muted">
                    <b>Contact Support by clicking the button below</b>
                  </h5>
                  <a
                    className="btn mt-3"
                    href="https://engageleads.zendesk.com/hc/en-us"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Click here to ask your queries.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Support;
